import React, { useEffect, useState } from "react";
import "./pages/modals/modals.scss";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch, useSelector } from "react-redux";
import {
  setUserRequest,
  setUserSuccess,
  setUserFailure,
  fetchRoomsRequest,
  fetchRoomsSuccess,
  fetchRoomsFailure,
  hideModal,
} from "./redux/actions";

/* COMPONENTS */
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import axios from "axios";
import Header from "./components/header/header";
import Navigation from "./components/navigation/navigation";
import Input from "./components/input/input";
import Button from "./components/button/button";
import Modal from "./components/modal/modal";
import Chip from "./components/chip/chip";
import Usercard from "./components/usercard/usercard";
import { ToastContainer, toast } from "react-toastify";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

/* PAGES */
import Landing from "./pages/landing/landing";
import Room from "./pages/room/room";

function App() {
  const socket = useSelector((state) => state.socket);
  const modal = useSelector((state) => state.modal);
  const room = useSelector((state) => state.room);
  const user = useSelector((state) => state.user);
  const admin = useSelector((state) => state.admin);
  const dispatch = useDispatch();

  const [topic, setTopic] = useState("");
  const [messageText, setMessageText] = useState();

  useEffect(() => {
    const eoLogin2 = window.location.href.split("eoLogin2=")[1];

    if (!user.data)
      if (eoLogin2) {
        dispatch(setUserRequest());
        axios
          .get(`/api/v1/users/signin?eoLogin2=${eoLogin2}`)
          .then((res) => dispatch(setUserSuccess(res.data)))
          .catch((err) => dispatch(setUserFailure(err)));
      } else {
        toast.error(
          "Ihre Sitzung ist abgelaufen. Klicken Sie hier um sich erneut anzumelden.",
          { onClick: () => window.open("https://www.kzvb.de", "_self") }
        );
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.data && user.data.state === 1) {
      toast.error(
        "Ihr Zugang wurde vom Administrator gesperrt, bitte wenden Sie sich an den Support auf www.kzvb.de für weitere Informationen.",
        { onClick: () => window.open("https://www.kzvb.de", "_self") }
      );
      dispatch(setUserFailure());
    }
  }, [user.data]);

  useEffect(() => {
    if (user.data) {
      // FETCH ROOMS
      dispatch(fetchRoomsRequest());
      axios
        .get("/api/v1/rooms")
        .then((res) => dispatch(fetchRoomsSuccess(res.data)))
        .catch((err) => dispatch(fetchRoomsFailure(err)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.data]);

  useEffect(() => {
    setMessageText(room.message.message);
  }, [room.message]);

  const postTopic = async (e) => {
    e.preventDefault();
    dispatch(hideModal());

    const payload = {
      title: topic,
    };

    await axios.post("/api/v1/rooms/create", payload);

    // FETCH ROOMS
    dispatch(fetchRoomsRequest());
    axios
      .get("/api/v1/rooms")
      .then((res) => dispatch(fetchRoomsSuccess(res.data)))
      .catch((err) => dispatch(fetchRoomsFailure(err)));
  };

  const editMessage = async (e) => {
    e.preventDefault();
    dispatch(hideModal());

    const payload = {
      messageID: room.message._id,
      message: messageText,
    };

    socket.emit("edit", payload);
  };

  const deleteAccount = async () => {
    // SET AUTH HEADER
    axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
      "kzvb-obleute"
    );

    await axios
      .delete("/api/v1/users/")
      .then(() => sessionStorage.removeItem("kzvb-obleute"))
      .catch((err) => toast.error(err.message))
      .finally(() => (window.location.href = "/"));
  };

  const updateRoomOrder = async (rooms) => {
    // SET AUTH HEADER
    axios.defaults.headers.common["x-auth-token"] = sessionStorage.getItem(
      "kzvb-obleute"
    );

    await axios
      .put("/api/v1/rooms/sort", rooms)
      .catch((err) => toast.error(err.message));
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = async (payload) => {
    // DROPPED OUTSIDE THE LIST
    if (!payload.destination) return;

    const rooms = reorder(
      room.data,
      payload.source.index,
      payload.destination.index
    );

    rooms.map((room, idx) => (room.order = idx));
    await updateRoomOrder(rooms);
    dispatch(fetchRoomsSuccess(rooms));
  };

  return (
    <div
      className={`app${
        user.data && user.data.state === 0 ? "" : "--unauthorized"
      }`}
    >
      <Router>
        <Header />
        {user.loaded && user.data && user.data.state === 0 && <Navigation />}
        <Switch>
          <Route path='/' exact component={Landing} />
          <Route path='/topic/:id' component={Room} />
        </Switch>
      </Router>

      <ToastContainer limit={8} />

      <Modal active={modal.active} title={modal.title} size={modal.size}>
        {modal.type === "topic" && (
          <React.Fragment>
            <h3 className='heading--3'>Neues Thema erstellen</h3>
            <form onSubmit={(e) => postTopic(e)}>
              <Input
                type='text'
                placeholder='Name'
                className='mt-3'
                onChange={(e) => setTopic(e.target.value)}
              />
              <Button
                type='submit'
                text='Erstellen'
                className='button-primary button--small mt-4'
              />
            </form>
          </React.Fragment>
        )}

        {modal.type === "settings" && (
          <React.Fragment>
            {user.data && user.data.admin && (
              <section className='settings__edit mb-4'>
                <h3 className='heading--3'>
                  <span className='icon icon--pencil-2 mr-3'></span>
                  <span>Themen verwalten</span>
                </h3>

                <DragDropContext onDragEnd={(payload) => onDragEnd(payload)}>
                  <Droppable droppableId='rooms' direction='horizontal'>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className='settings__list dragging'
                      >
                        {room.data &&
                          room.data.map((room, idx) => (
                            <Draggable
                              key={room._id}
                              draggableId={room._id}
                              index={idx}
                            >
                              {(provided, snapshot) => (
                                <React.Fragment>
                                  <Chip
                                    reference={provided.innerRef}
                                    {...provided.draggableProps}
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style
                                    )}
                                    {...provided.dragHandleProps}
                                    type='room'
                                    room={room}
                                  />
                                  {provided.placeholder}
                                </React.Fragment>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </section>
            )}

            {user.data && user.data.admin && (
              <section className='settings__edit mt-5'>
                <h3 className='heading--3'>
                  <span className='icon icon--bubbles-2 mr-3'></span>
                  <span>Gemeldete Benutzer</span>
                </h3>
                {admin.loaded ? (
                  <div className='settings__list'>
                    {admin.reported.length > 0 ? (
                      admin.reported.map((user) => (
                        <Usercard key={user._id} data={user} />
                      ))
                    ) : (
                      <p>Derzeit gibt es keine gemeldeten Nutzer</p>
                    )}
                  </div>
                ) : (
                  <div className='settings__list'>...</div>
                )}
              </section>
            )}

            <section className='settings__edit mt-5'>
              <h3 className='heading--3'>
                <span className='icon icon--cogs mr-3'></span>
                <span>Kontoeinstellungen</span>
              </h3>
              <p className='mt-2'>
                Bitte beachten Sie: wenn das Konto gelöscht wird, werden Ihre
                Nachrichten als "Gelöschtes Konto" weiterhin angezeigt.
              </p>
              <p>
                Sie können diese Plattform weiterhin über den Internetauftritt
                der KZVB aus dem gesicherten Bereich erreichen. Dadurch wird ein
                neues Konto für Sie auf dieser Plattform angelegt.
              </p>
              <Button
                className='button-danger button--small mt-4'
                onClick={() => deleteAccount()}
                text='Konto löschen'
              />
            </section>
          </React.Fragment>
        )}

        {modal.type === "message-edit" && (
          <React.Fragment>
            <h3 className='heading--3'>Nachricht bearbeiten</h3>
            <form onSubmit={(e) => editMessage(e)}>
              <textarea
                name=''
                id=''
                cols='30'
                rows='10'
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                required
              ></textarea>
              <Button
                type='submit'
                text='Bestätigen'
                className='button-primary button--small mt-3'
              />
            </form>
          </React.Fragment>
        )}

        {modal.type === "terms" && (
          <React.Fragment>
            <h3 className='heading--3'>
              <span className='icon icon--bubbles-2 mr-2'></span>
              <span>Richtlinien</span>
            </h3>
            <p>
              Das Obleuteforum der KZVB ist Bestandteil des Internetauftritts
              der Kassenzahnärztlichen Vereinigung Bayerns. Hier soll eine
              offene Diskussion zwischen allen Teilnehmern möglich sein. Bitte
              achten Sie darauf, in diesem Forum einen sachlichen Ton zu wahren.
            </p>
            <p>
              Die Redaktion behält sich vor, beleidigende, grob anstößige, sowie
              strafrechtlich relevante Äußerungen und Beiträge zu löschen. Das
              Copyright für die Beiträge, soweit diese dem Urheberrecht
              unterliegen, verbleiben grundsätzlich beim Verfasser, mit der
              Einschränkung, dass der Verfasser der KZVB mit dem Einstellen das
              Recht gibt, die verfassten Mitteilungen dauerhaft auf den
              Forumsseiten zu belassen, jedoch bei einer Lösung des
              Benutzerkontos zu anonymisieren. Jede Veröffentlichung der
              Forumsbeiträge durch Dritte bedarf der Zustimmung des Verfassers.
              Teilnehmer, die gegen diese Forums-Etikette verstoßen, können von
              der Teilnahme an den Diskussionen ausgeschlossen werden.
            </p>
            <p>
              Wir wünschen viel Spaß bei der Diskussion in unserem Forum.
              Online-Redaktion der Kassenzahnärztlichen Vereinigung Bayerns
            </p>
          </React.Fragment>
        )}
      </Modal>
    </div>
  );
}

export default App;
